import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILocalizacao } from '../../../models';

interface ILocalizacaoState {
  localizacoes: ILocalizacao[]
  openLocalizacaoDialog: boolean
  searchTerm: string,
  categoria: keyof ILocalizacao
}

const initialState: ILocalizacaoState = {
  localizacoes: [],
  openLocalizacaoDialog: false,
  searchTerm: '',
  categoria: 'macrorregiao'
};

const localizacaoSlice = createSlice({
  name: 'localizacao',
  initialState,
  reducers: {
    setLocalizacoesState(state, action: PayloadAction<{
      localizacoes: ILocalizacao[]
    }>) {
      state.localizacoes = action.payload.localizacoes
    },
    resetLocalizacoesListInitialState(state) {
        state.localizacoes = initialState.localizacoes
    },
    resetLocalizacaoInitialState(state) {
      state = initialState
    },
    setLocalizacaoSearchTermState(state, action: PayloadAction<{
      searchTerm: string
    }>) {
      state.searchTerm = action.payload.searchTerm
    },
    resetLocalizacaoSearchTermState(state) {
      state.searchTerm = initialState.searchTerm
    },
    setLocalizacaoCategoriaState(state, action: PayloadAction<{
      categoria: keyof ILocalizacao
    }>) {
      state.categoria = action.payload.categoria
    },
    setOpenLocalizacaoDialogState(state, action: PayloadAction<boolean>) {
      state.openLocalizacaoDialog = action.payload
    }
  },
});

export const {
  setLocalizacoesState,
  resetLocalizacaoInitialState,
  setLocalizacaoSearchTermState,
  setLocalizacaoCategoriaState,
  setOpenLocalizacaoDialogState,
  resetLocalizacaoSearchTermState,
  resetLocalizacoesListInitialState
} = localizacaoSlice.actions;

export const localizacaoReducer = localizacaoSlice.reducer;